import React from 'react';
import {
  ArrowRightIcon,
  HandThumbUpIcon as ThumbUp,
} from '@heroicons/react/24/outline';
import H2 from '@teetsh/app/src/components/Typography/Headings/H2';
import { Transition } from '@headlessui/react';
import tw from 'twin.macro';
import styled from '@emotion/styled';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { Infobox } from 'components/Callout/Infobox';

interface Props {
  show: boolean;
  number?: number;
  successCta?: string;
  onSuccess: () => void;
}

const StyledTransition = styled.div`
  .enter {
    ${tw`transition duration-300 ease-out`}
  }

  .enterFrom {
    ${tw`transform opacity-0`}
  }

  .enterTo {
    ${tw`transform opacity-100`}
  }

  .leave {
    ${tw`transition duration-300 ease-out`}
  }

  .leaveFrom {
    ${tw`transform opacity-100`}
  }

  .leaveTo {
    ${tw`transform opacity-0`}
  }
`;

export function Success(props: Props) {
  const { number = 0, show, onSuccess, successCta } = props;
  const { t } = useTranslation(['eleve']);
  return (
    <StyledTransition>
      <Transition
        show={show}
        enter="enter"
        enterFrom="enterFrom"
        enterTo="enterTo"
        leave="leave"
        leaveFrom="leaveFrom"
        leaveTo="leaveTo"
      >
        <div tw="flex flex-col items-center justify-center">
          <Infobox
            intent="success"
            tw="text-center max-w-2xl flex-grow mb-8"
            icon={null}
          >
            <ThumbUp tw="inline-block h-20 w-20 text-positive-intense" />
            <div tw="pt-5">
              <H2>
                {t('eleve:import.xElevesImportedSuccessfully', {
                  count: number,
                })}
              </H2>
            </div>
          </Infobox>
          <div>
            <Button
              onClick={() => onSuccess()}
              large
              intent="primary"
              rightIcon={ArrowRightIcon}
            >
              {successCta || t('eleve:import.goToEleves')}
            </Button>
          </div>
        </div>
      </Transition>
    </StyledTransition>
  );
}
